import { z } from 'zod';
import { tourProofSchema, type TourProof } from '@erp/shared';

const storedSchema = z.object({
  scope: z.string(),
  stopId: z.string(),
  savedAt: z.string().datetime(),
  body: tourProofSchema,
});
export interface DeliveryDraft {
  scope: string;
  stopId: string;
  savedAt: string;
  body: TourProof;
}
export const deliveryDraftKey = (scope: string, stopId: string) =>
  `erp.delivery-draft.v1.${scope}.${stopId}`;
export function readDeliveryDraft(
  storage: Pick<Storage, 'getItem'>,
  scope: string,
  stopId: string,
): DeliveryDraft | null {
  try {
    const value = storage.getItem(deliveryDraftKey(scope, stopId));
    if (value === null) return null;
    const parsed = storedSchema.safeParse(JSON.parse(value));
    return parsed.success && parsed.data.scope === scope && parsed.data.stopId === stopId
      ? parsed.data
      : null;
  } catch {
    return null;
  }
}
export function storeDeliveryDraft(storage: Pick<Storage, 'setItem'>, draft: DeliveryDraft) {
  storage.setItem(
    deliveryDraftKey(draft.scope, draft.stopId),
    JSON.stringify(storedSchema.parse(draft)),
  );
}
export function removeDeliveryDraft(
  storage: Pick<Storage, 'removeItem'>,
  scope: string,
  stopId: string,
) {
  storage.removeItem(deliveryDraftKey(scope, stopId));
}
